/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { GridOffset } from "@insite/mobius/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { lineStyle } from "@monsma/App/Components/LineContainer/LineContainer";
import { quickOrderProductListStyles } from "@monsma/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import { css } from "styled-components";

quickOrderProductListStyles.wrapper = {
    css: css`
        padding-bottom: 20px;
        padding-top: 20px;
        border-top: 1px solid ${getColor("common.ui12")};

        ${GridOffset} {
            width: 100%;
            margin-left: 0;
        }
    `,
};

quickOrderProductListStyles.totalText = {
    css: css`
        float: right;
        font-weight: bold;
        margin: 15px 0;
        margin-bottom: 30px;
    `,
};

quickOrderProductListStyles.addToListLink = {
    link: {
        ...lineStyle.addToListLink,
        css: css`
            ${lineStyle.addToListLink!.css};
            left: 0;
        `,
    },
};
